import React, { useState, useEffect, useContext} from 'react';
import MUIDataTable from 'mui-datatables';

// material
import {
    Stack,
    Alert,
    Container,
    Typography,
    MenuItem,  
    ListItemIcon, 
    ListItemText,
    AlertTitle,
  } from '@mui/material';

import {api, reiniciarToken, consultaTipoDespesas, excluirTipoDespesas} from '../../../services/api';
// context
import { AuthContext } from '../../../contexts/auth';  

import Page from '../../../components/Page';
import Iconify from '../../../components/Iconify';

// utils
import CadTipoDespesaForm from '../../FormsTemplates/Despesa/TipoDespesa/CadastroTipoDespesaForms';


export default function CadastroTipoDespesa() {

  const { logout } = useContext(AuthContext);
  const [dados, setData] = useState([]);
  
  const getTipoDespesas = async () => {
    const retorno = await reiniciarToken();
    if(retorno.erro === true) {
      if (retorno.mensagem === 'O Token é inválido!' || retorno.mensagem === 'Acesso negado!'){
        logout();
      }
    }else{
      localStorage.setItem("token", retorno.data.token);
      api.defaults.headers.Authorization = `Bearer ${retorno.data.token}`;
    }

    const response = await consultaTipoDespesas();
    if(response.erro === true) {
      if (response.mensagem === 'O Token é inválido!' || response.mensagem === 'Acesso negado!'){
        logout();
      }
    }else {
      response.data.forEach((valores) => {
        setData(dados => [...dados, {id_tipo_despesa: valores.id_tipo_despesa,
                                     descricao: valores.descricao}]);
      });
    }; 
  }

  useEffect(() => {
    getTipoDespesas();
  },[])  

  const [status, setStatus] = useState({
    type: '',
    mensagem: ''
  }) 
  
  
  const excluirTipoDespesa = async (id) => {
    const response = await excluirTipoDespesas(id);
    if(response.erro === true) {
      if (response.mensagem === 'O Token é inválido!' || response.mensagem === 'Acesso negado!'){
        logout();
      }else {
        setStatus({
          type: "erro",
          mensagem: response.mensagem
        })
      }
    }else {
      setStatus({
        type: "success",
        mensagem: response.data.mensagem
      })
      setData([]);
      getTipoDespesas();
    }; 
  } 

  const columns = [{name: "Ação",
                    options: {
                      filter: false,
                      sort: false,
                      empty: true,
                      customBodyRenderLite: (dataIndex, rowIndex) =>  {
                        return (
                          <> 
                            <MenuItem onClick={() => excluirTipoDespesa(dados[dataIndex].id_tipo_despesa)} sx={{ color: 'text.secondary' }}>
                              <ListItemIcon>
                                  <Iconify icon="eva:trash-2-outline" width={24} height={24} />
                              </ListItemIcon>
                              <ListItemText primary="Excluir da Lista" primaryTypographyProps={{ variant: 'body2' }} />
                            </MenuItem>
                          </> 
                        );
                      }
                    }
                  }
                  ,{name:"descricao", label: "Descrição"}
                  ];

  const options = {
    filterType: "dropdown",
    tableBodyHeight: "100%",
    selectableRows: "none",
    responsive: "standard",
    selectToolbarPlacement: "none",
    print:'false',
    search: 'false',
    download: 'false',
    filter: 'false',
    viewColumns: 'false',
  };             
                    
  return (
    <Page title="Tipo Despesa">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Cadastro Tipo Despesa
          </Typography>
        </Stack>

        <Stack mb={2} spacing={10}>
          <CadTipoDespesaForm/>
        </Stack>

        <Stack spacing={3}>
          {status.type === 'erro' ? <Alert severity="error"><AlertTitle>Erro</AlertTitle>{status.mensagem}</Alert> : ""}
          {status.type === 'success' ? <Alert severity="success"><AlertTitle>Sucesso</AlertTitle>{status.mensagem}</Alert> : ""}
        </Stack > 

        <Stack mb={2} spacing={10}>
          <MUIDataTable
              data={Object.values(dados)}
              columns={columns}  
              options={options} 
          />
        </Stack>
      </Container>  
    </Page>  
  );
}

